import React from 'react';
import { Navigate } from 'react-router-dom';

export default function Money() {
  return <Navigate to="/transactions" replace />;
}
